module.exports = __webpack_public_path__ + "static/media/minimize-icon.8c7c126c.svg";